import React, { SetStateAction } from 'react'
import { ITag } from 'core/interfaces/Tag'
import { ModalHeader } from 'core/components/common/ModalHeader'
import ModalWrapper from 'core/components/common/ModalWrapper'
import { ModalBody } from 'core/components/common/ModalBody'
import { Trans, useTranslation } from 'react-i18next'
import { useDeleteTagMutation } from 'core/api/tag'

export const DeleteTagModal: React.FC<{
  open: boolean
  setOpen: (value: SetStateAction<boolean>) => void
  tag: ITag | null
}> = ({ open, setOpen, tag }) => {
  const { t } = useTranslation()
  const [deleteTag, { isLoading }] = useDeleteTagMutation()

  const hide = (event: any) => {
    event.preventDefault()
    setOpen(false)
  }
  const handleDelete = () => {
    if (tag) {
      deleteTag(tag.id)
        .unwrap()
        .then(() => {
          setOpen(false)
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  return (
    <ModalWrapper
      classNames={{ modal: 'modal modal-tag' }}
      onClose={() => setOpen(false)}
      open={open}
      showCloseIcon={false}
    >
      <ModalHeader titleClassName="modal-title mt-[30px]">
        {t('tags.delete.title')}
      </ModalHeader>
      <ModalBody className="my-[30px] ml-[30px]">
        <div>
          <Trans i18nKey="tags.delete.texte" values={{ label: tag?.nomTag }} />
        </div>
        <div
          className={`text-right self-end w-full md:block mt-[30px] pr-[40px]`}
        >
          <button
            className="small-btn cancel hidden text-[14px]"
            onClick={hide}
          >
            {t('global.form.button.cancel')}
          </button>
          <button
            disabled={isLoading}
            className="small-btn default w-full md:w-[220px] md:ml-30px text-[14px]"
            onClick={handleDelete}
          >
            {t('tags.delete.button')}
            {isLoading && (
              <span className="button-loader ml-2 align-middle"></span>
            )}
          </button>
        </div>
      </ModalBody>
    </ModalWrapper>
  )
}
